<div class="p-grid ">
    <div class="p-col-10 m-auto p-mt-5">
      <div class="p-col-12">
        <h2 class="titulo">Aviso legal</h2>
        <div class="cuerpo">
            En cumplimiento de lo previsto en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, se pone en conocimiento de los usuarios del sitio web www.valladolidadelante.es (en adelante el “sitio web”) los siguientes datos de información general:<br/>
            1.	El titular del sitio web es el Ayuntamiento de Valladolid.<br/>
            2.	El domicilio del titular se encuentra en Plaza Mayor 1, 47001, Valladolid (España).<br/>
            3.	El Ayuntamiento de Valladolid está provisto del CIF P4718700J.<br/>
            4.	Los usuarios del presente sitio web podrán establecer una comunicación directa y efectiva con el Ayuntamiento de Valladolid mediante comunicación escrita remitida al domicilio indicado en el punto 2 de los que componen este Aviso Legal, así como utilizando cualquiera de los siguientes medios:<br/>
        -	<b>Teléfono: +34 983426100</b><br/>
        -	<b>Email: <a href="mailto:dpd@ava.es">dpd@ava.es</a></b><br/>
        -	<b>Formulario de contacto: <a target="_blank" href="https://www.valladolid.gob.es/es/reclamaciones-sugerencias">https://www.valladolid.gob.es/es/reclamaciones-sugerencias</a><br/></b>
        (*) La utilización de las anteriores vías de contacto supone la aceptación del tratamiento de los datos aportados con la finalidad de tramitar su consulta, según la Política de Privacidad publicada en ese sitio web (enlazar a  /politica-de-privacidad)<br/>
        </div>
   
      </div>
    </div>
</div>


